export default "/images/file-text.svg?cb094fae8eba3fdd4b841eca5f2c4d44";